import React, { useEffect, useState } from 'react';
import { DataTableColumn } from '@common/components/datatable/types';
import { useTranslation } from 'react-i18next';
import { Button } from '@common/components/button';

type CommunityGroup = {
  externalId: string;
  name: string;
  linked_with: any[];
};

type Props = {
  onImportCommunity: (community: CommunityGroup) => void;
};

export default ({ onImportCommunity }: Props) => {
  const { t } = useTranslation();
  const [columns, setColumns] = useState<DataTableColumn[]>([]);

  useEffect(() => {
    const baseColumns: DataTableColumn[] = [
      {
        key: 'name',
        label: t('organisation:sync_result_name'),
        options: {
          render: (community: CommunityGroup) => (
            <p>{community.name}</p>
          ),
        },
      },
      {
        key: 'action',
        label: '',
        options: {
          align: 'right',
          render: (community: CommunityGroup) => (
            <div className="tw-flex tw-justify-end">
              <Button
                onClick={() => onImportCommunity(community)}
              >
                {t('organisation:import')}
              </Button>
            </div>
          ),
        },
      },
    ];
    setColumns(baseColumns);
  }, [t]);

  return columns;
};
